// Pienentää kuvan selaimessa ennen latausta, jotta puhelimen isoja kuvia (5–20 MB) ei siirretä
// mobiiliverkossa turhaan. Palvelin pienentää pakatut kuvat joka tapauksessa samaan kokoon,
// joten epäonnistuessa palautetaan alkuperäinen tiedosto.
// EXIF-asento: selaimet kääntävät <img>:n EXIFin mukaan, joten canvasille piirretty kuva on jo oikein päin.
// Muut EXIF-tiedot katoavat, mutta niin käy myös palvelimen pakkauksessa.

const RESIZABLE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = e => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}

export async function downscaleImage(file, maxSize = 1500, quality = 0.85) {
  if (!file || !RESIZABLE_TYPES.includes(file.type)) return file;
  try {
    const img = await loadImage(file);
    const longestSide = Math.max(img.naturalWidth, img.naturalHeight);
    if (longestSide <= maxSize) return file;

    const scale = maxSize / longestSide;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    // JPEG ei tue läpinäkyvyyttä: valkoinen tausta kuten palvelimen pakkauksessa
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob) return file;
    return new File([blob], file.name, { type: 'image/jpeg' });
  } catch (e) {
    console.warn('Image downscale failed, uploading original', e);
    return file;
  }
}
